import type {
  FormattedMemberChangeLogs,
  MemberChangeLogsResponse
} from '@library/types/members/memberChangeLogs';
import { removeUnderscore } from '@bo-utils/common';

export const transformMemberChangeLogs = (
  response: MemberChangeLogsResponse | undefined
): FormattedMemberChangeLogs | undefined => {
  if (!response) {
    return undefined;
  }

  const { data, included } = response;

  const changeLogs = data.map((changeLog) => {
    const { attributes, relationships } = changeLog;
    const { admin_user: adminUser } = relationships;
    const { attributes: adminUserAttr } =
      included?.find(({ id }) => id === adminUser.data.id) ?? {};
    const {
      first_name: firstName,
      last_name: lastName,
      email = 'N/A'
    } = adminUserAttr ?? {};
    const fullName = firstName && lastName ? `${firstName} ${lastName}` : 'N/A';

    return {
      adminUser: {
        email,
        fullName
      },
      createdAt: attributes.created_at,
      description: attributes.description,
      id: changeLog.id,
      noteType: attributes.note_type
        ? removeUnderscore(attributes.note_type)
        : 'N/A'
    };
  });

  const sortedChangeLogs = changeLogs.toSorted(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  );

  return sortedChangeLogs;
};
